import React, { Component } from 'react';
import axios from 'axios';
import { Trans } from 'react-i18next';
import { withRouter } from 'react-router';

class ErrorBoundary extends Component {
    constructor(props) {
      super(props);

      this.state = {
          error: null,
          errorInfo: null,
          hasError: false
      }
      const {history} = this.props;

      history.listen((location, action) => {
          if (this.state.hasError) {
              this.setState({hasError: false})
          }
      })

      this.refreshPage = this.refreshPage.bind(this);
      this.goHome = this.goHome.bind(this);
    }
    
    componentDidCatch(error, errorInfo) {
      // Catch errors in any components below and re-render with error message
      this.setState({
          error: error,
          errorInfo: errorInfo,
          hasError: true
      })

      axios.post('/ajax/error', {
          error: (error.name + ": " + error.message),
          error_stack: (error.stack + "\n\nReact Stack:\n" + errorInfo.componentStack),
          error_type: 'FRONTEND',
          page: window.location.pathname
      })
    }

    refreshPage() {
        axios.post('/ajax/error/updateRefresh', {
            error: (this.state.error.name + ": " + this.state.error.message),
            error_stack: (this.state.error.stack + "\n\nReact Stack:\n" + this.state.errorInfo.componentStack),
            error_type: 'FRONTEND'
        })
        window.location.reload();
    }

    goHome() {
        axios.post('/ajax/error/updateHome', {
            error: (this.state.error.name + ": " + this.state.error.message),
            error_stack: (this.state.error.stack + "\n\nReact Stack:\n" + this.state.errorInfo.componentStack),
            error_type: 'FRONTEND'
        })
    }
    
    render() {
        if (this.state.hasError) {
            // Error path
            return (
                <div className = "errorpage-wrapper">
                    <img src = "/images/404.png" />
                    <h1 className = "mt-24 mb-24"><Trans>There was an error in displaying this page.</Trans></h1>
                    <div onClick={this.refreshPage} className = "button primary no-margin"><Trans>Refresh Page</Trans></div>
                    <div className = "mt-16">
                        <p className = "caption"><Trans>Refresh not working?</Trans> <a onClick={this.goHome} className = "link" href="/"><Trans>Go back to home</Trans></a> </p>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }  
}

export default withRouter(ErrorBoundary);